module.exports = __webpack_public_path__ + "static/media/Acres.28442b39.svg";